export default __webpack_public_path__ + "static/media/info10_Sede_examen.e6e17e9a.png";